export default __webpack_public_path__ + "static/media/sound.4f6db54c.mp3";